import { useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

export const paymentSchemasQueryKeys = {
  all: ['paymentSchemas'],
  errorPayments: () => [...paymentSchemasQueryKeys.all, 'errorPayments'],
  manualPayments: () => [...paymentSchemasQueryKeys.all, 'manualPayments'],
};

export function useGetErrorPaymentsSchema() {
  return useQuery({
    queryKey: paymentSchemasQueryKeys.errorPayments(),
    queryFn: async () => {
      const schemas = await VendorsService.getErrorPaymentsSchema();
      return schemas;
    },
  });
}

export function useGetManualPaymentsSchema() {
  return useQuery({
    queryKey: paymentSchemasQueryKeys.manualPayments(),
    queryFn: async () => {
      const schemas = await VendorsService.getManualPaymentsSchema();
      return schemas;
    },
  });
}
